import { ReactElement } from "react";

import { getServerSideProps } from "../../../screens/LandingScreen/getServerSideProps";
import LandingScreen from "../../../screens/LandingScreen";
import LandingPageLayout from "../../../layouts/LandingPageLayout";

import type { LandingScreenProps } from "../../../screens/LandingScreen/LandingScreen";

const LandingScreenWrapper = (props: LandingScreenProps) => {
  return <LandingScreen {...props} />;
};

LandingScreenWrapper.getLayout = function getLayout(page: ReactElement) {
  const { props } = page;
  return <LandingPageLayout config={props?.config}>{page}</LandingPageLayout>;
};

export { getServerSideProps };

export default LandingScreenWrapper;
